import { call, put, all, takeEvery, select } from "redux-saga/effects";

import { tourTypeActions } from '../slice/tourTypeSlice'
import {
    getAllApi,
    getAllAndFilterTourTypeApi,
    createTourTypeApi,
    updateTourTypeApi,
    removeTourTypeApi,
    getByTourTypeSlugApi
} from 'services/tourTypeServices'
import { tourTypeSelector } from "redux/selector"

function* handleGetAllTourType() {
    try {
        const res = yield call(getAllApi)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourTypeActions.getTourTypeAllSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(tourTypeActions.getTourTypeAllFailed())
            }
        }
        else {
            yield put(tourTypeActions.getTourTypeAllFailed())
        }
    } catch (error) {
        yield put(tourTypeActions.getTourTypeAllFailed())
    }
}

function* handleGetTourType(action) {
    try {
        const res = yield call(getAllAndFilterTourTypeApi, action.payload.query, action.payload.currentPage)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourTypeActions.getTourTypeSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(tourTypeActions.getTourTypeFailed())
            }
        }
        else {
            yield put(tourTypeActions.getTourTypeFailed())
        }
    } catch (error) {
        yield put(tourTypeActions.getTourTypeFailed())
    }
}


function* handleGetTourByTourType(action) {
    try {
        const res = yield call(getByTourTypeSlugApi, action.payload.slug, action.payload.query, action.payload.min, action.payload.max, action.payload.sort, action.payload.page, action.payload.perPage, action.payload.person)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourTypeActions.getToursSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(tourTypeActions.getToursFailed())
            }
        }
        else {
            yield put(tourTypeActions.getToursFailed())
        }
    } catch (error) {
        yield put(tourTypeActions.getToursFailed())
    }
}


function* handleCreateTourType(action) {
    try {
        const res = yield call(createTourTypeApi, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourTypeActions.addTourTypeSuccess())
                action.payload.ShowToast('success', 'Thêm loại tour thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(tourTypeActions.getTourType({ query: action.payload.querySearch, currentPage: action.payload.currentPage }))
            } else {
                yield put(tourTypeActions.addTourTypeFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Thêm loại tour thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(tourTypeActions.addTourTypeFailed())
            action.payload.ShowToast('error', 'Thêm loại tour thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(tourTypeActions.addTourTypeFailed())
        action.payload.ShowToast('error', 'Thêm loại tour thất bại, vui lòng thử lại sau!')
    }
}


function* handleUpdateTourType(action) {
    try {
        const res = yield call(updateTourTypeApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourTypeActions.updateTourTypeSuccess())
                action.payload.ShowToast('success', 'Cập nhật loại tour thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(tourTypeActions.getTourType({ query: action.payload.querySearch, currentPage: action.payload.currentPage }))

            } else {
                yield put(tourTypeActions.updateTourTypeFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Cập nhật loại tour thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(tourTypeActions.updateTourTypeFailed())
            action.payload.ShowToast('error', 'Cập nhật loại tour thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(tourTypeActions.updateTourTypeFailed())
        action.payload.ShowToast('error', 'Cập nhật loại tour thất bại, vui lòng thử lại sau!')
    }
}



function* handleRemoveTourType(action) {
    try {
        const res = yield call(removeTourTypeApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourTypeActions.removeTourTypeSuccess())
                const tourTypeState = yield select(tourTypeSelector)
                let totalPage = tourTypeState.totalPage
                if (tourTypeState.tourTypeList.length === 1) {
                    totalPage = totalPage - 1
                    yield put(tourTypeActions.setTotalPage(totalPage))
                    action.payload.setCurrentPage(action.payload.currentPage - 1)
                    yield History.navigate(`/admin/tour-type?page=${action.payload.currentPage - 1}`);
                }
                action.payload.ShowToast("success", 'Xóa loại tour thành công!')
                yield put(tourTypeActions.getTourType({ query: action.payload.querySearch, currentPage: action.payload.currentPage }))
            } else {
                yield put(tourTypeActions.removeTourTypeFailed())
                action.payload.ShowToast('error', `${response.data[1]}`)
            }
        }
        else {
            yield put(tourTypeActions.removeTourTypeFailed())
            action.payload.ShowToast('error', `Xóa loại tour thất bại, loại tour đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
        }
    } catch (error) {
        yield put(tourTypeActions.removeTourTypeFailed())
        action.payload.ShowToast('error', `Xóa loại tour thất bại, loại tour đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
    }
}


export default function* tourTypeSaga() {
    yield all(
        [
            takeEvery(tourTypeActions.getTourTypeAll.type, handleGetAllTourType),
            takeEvery(tourTypeActions.getTourType.type, handleGetTourType),
            takeEvery(tourTypeActions.addTourType.type, handleCreateTourType),
            takeEvery(tourTypeActions.updateTourType.type, handleUpdateTourType),
            takeEvery(tourTypeActions.removeTourType.type, handleRemoveTourType),
            takeEvery(tourTypeActions.getTours.type, handleGetTourByTourType),
        ]
    )
}
